import React from 'react';
import {changeRingSize} from "../lib/actions";
import {connect} from "react-redux";

class SizeSelector extends React.Component {
    render() {
        return (
            <div className='product__options'>
                <div className="product__length-option-name-container">
                    <h4 className="product__option-name">Size</h4>
                </div>
                <div className="product__dropdown-container">
                    <select name="Ring size" value={this.props.selectedSize} onChange={(e) => this.props.onChange(e.target.value)}>
                        {Array(57).fill('').map((v, index) => <option key={index} value={2 + index * .25}>{2 + index * .25}</option>)}
                    </select>

                    <div className="product__dropdown-note">
                        <a href="/products/ring-sizer" target="_blank">Ring sizer</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        selectedSize: state.ringSize,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (ringSize) => {
            dispatch(changeRingSize(ringSize));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SizeSelector);
